import { render, staticRenderFns } from "./homeSwiper.vue?vue&type=template&id=53cba6d1&scoped=true"
import script from "./homeSwiper.vue?vue&type=script&lang=js"
export * from "./homeSwiper.vue?vue&type=script&lang=js"
import style0 from "./homeSwiper.vue?vue&type=style&index=0&id=53cba6d1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cba6d1",
  null
  
)

export default component.exports